import { AfterViewInit, Component, Input } from '@angular/core';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
declare let google: any;
@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html',
  styleUrl: './mapa.component.css'
})
export class MapaComponent implements AfterViewInit {
  @Input() company!: Company;
  nameCompany = '';
  mapComplete: boolean = false;

  constructor(private connection: ConnectionService){}

  ngAfterViewInit(): void {
    this.loadGoogleMapsScript().then(() => {
      setTimeout(() => {
        this.initMap();
      }, 1000);

    });
    this.connection.nameCompany$.subscribe((data) =>{
      this.nameCompany = data;
    })
  }


  loadGoogleMapsScript(): Promise<void> {
    return new Promise(resolve => {
      if (document.getElementById('google-maps-script')) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.id = 'google-maps-script';
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDEery5dhm2b_jwc_VlgD9H4DCCeShtmyE&callback=initMapCallback';
      script.async = true;
      script.defer = true;
      (window as any)['initMapCallback'] = () => resolve();
      document.body.appendChild(script);
    });
  }

  initMap(): void {
    const address = this.company.company.address
    if(address.lat && address.long && !this.mapComplete && document.getElementById("map"))
    {
      this.mapComplete = true;
      // console.log('Mapa renderizado')
      const local = { lat: Number(address.lat), lng: Number(address.long) };

      if(google){
        const map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
          center: local,
          zoom: 16,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          scrollwheel: false,
          disableDefaultUI: true,
        });
    
        new google.maps.Marker({
          position: local,
          map,
          title: this.nameCompany
        });
      
      }

    }

  }
}
